import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import DocumentFilters from "../components/Filters/DocumentFilters";

export default function NotificationDocumentFiltersMobile({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose} className="z-[120]">
      <div className="fixed inset-0 z-[120] overflow-y-auto overflow-x-hidden touch-auto bg-white">
        <div className="min-h-full bg-white py-6">
          <div className="border-b border-[#D1D5DB] pb-6">
            <div className="flex items-center justify-between gap-4 px-6">
              <span className="text-[18px] leading-[28px] font-medium text-[#111827]">
                Фильтры уведомления
              </span>
              <button type="button" onClick={onClose}>
                <span className="sr-only">Close</span>
                <XMarkIcon className="h-6 w-6 text-[#111827]" />
              </button>
            </div>
          </div>

          <div className="flex flex-col px-5 custom-selects">
            <div className="relative filters-date-no-remove">
              <DocumentFilters />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
